import { Component, Input, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import { StarsDeliveryComponent } from "./starsDelivery/starsDelivery.component";
import { environment } from '../../../../../../../environments/environment';


@Component({
  selector: 'app-chat-header',
  standalone: true,
  imports: [StarsDeliveryComponent],
  template: `
    <div class="bg-gray-400 text-white p-2 sm:p-3 lg:p-4 rounded-t-lg flex items-center justify-between">
      <div class="flex items-center space-x-2 sm:space-x-3 flex-1 min-w-0">
        <div class="w-8 h-8 sm:w-10 sm:h-10 bg-gray-300 rounded-full flex items-center justify-center font-bold text-sm sm:text-lg flex-shrink-0">
          <img class="w-full h-full rounded-full" [src]="imageUrl()" alt="Foto del repartidor" (error)="onImgError()">
        </div>

        <div class="min-w-0 flex-1">
          <h3 class="font-semibold text-sm sm:text-base lg:text-lg truncate">{{ repartidor }}</h3>
          <p class="text-xs sm:text-sm opacity-90 truncate">
            <span class="inline-block animate-pulse h-1.5 w-1.5 sm:h-2 sm:w-2 bg-green-400 rounded-full mr-1 sm:mr-2"></span>
            <span class="hidden sm:inline">En línea - Responde rápido</span>
            <span class="sm:hidden">En línea</span>
          </p>
        </div>

        <div class="flex-shrink-0">
          <stars-delivery [idDelivery]="idDelivery"></stars-delivery>
        </div>
      </div>
    </div>
  `
})
export class ChatHeaderComponent implements OnChanges, OnInit {
  @Input() repartidor: string = '';
  @Input() idDelivery: number = 0;
  @Input() picture_delivery: string = '';

  // Base del backend que sirve las imágenes de repartidor
  private readonly baseUrl = environment.panelImagenesRepartidor;
  imageUrl = signal('');


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['idDelivery']) {
      this.idDelivery = changes['idDelivery'].currentValue;
    }
    if (changes['repartidor']) {
      this.repartidor = changes['repartidor'].currentValue;
    }
    if (changes['picture_delivery']) {
      this.picture_delivery = changes['picture_delivery'].currentValue;
      this.imageUrl.set(this.buildImageUrl());
    }
  }

  ngOnInit(): void {
    this.imageUrl.set(this.buildImageUrl());
    // console.log('foto de repartidor en el chat', this.imageUrl());
  }


  private buildImageUrl(): string {
    const src = this.picture_delivery || '';
    // Fallback si no hay imagen
    const defaultPath = '/storage/Repas/Repa-default.png';

    // Si la entrada viene como URL completa, usarla tal cual
    if (src.startsWith('http://') || src.startsWith('https://')) {
      return src;
    }

    // Normalizar base y path relativo
    const cleanBase = this.baseUrl.replace(/\/+$/, '');
    const cleanPath = src ? (src.startsWith('/') ? src : `/${src}`) : defaultPath;
    return `${cleanBase}${cleanPath}`;
  }

  onImgError(): void {
    // Forzar fallback al default si la imagen falla
    const cleanBase = this.baseUrl.replace(/\/+$/, '');
    this.imageUrl.set(`${cleanBase}/storage/Repas/Repa-default.png`);
  }




}
